import { useContext } from 'react';

import styled from '@emotion/styled';

import { TableContext } from '../../../components/Table/TableContext';
import {
  TRANSACTION_FUNDING_OPTIONS,
  TRANSACTION_SOURCE_OPTIONS,
  TRANSACTION_STATUS_OPTIONS,
  TRANSACTION_TYPE_OPTIONS,
} from '../../../models/transactions/filters.model';
import { capitalize } from '../../../utils/utils';

const TransactionFiltersBar = () => {
  const tableContext = useContext(TableContext);

  const setFilter = (key: string, value: string) =>
    tableContext?.handleSetTableFilterRecord({ [key]: value, page: 0 });

  return (
    <Container>
      <Select
        defaultValue=''
        onChange={(e) => setFilter('status', e.target.value)}
        aria-label='Filter by status'
      >
        <option value=''>All statuses</option>
        {TRANSACTION_STATUS_OPTIONS.map((status) => (
          <option key={status} value={status}>
            {capitalize(status.replace('_', ' '))}
          </option>
        ))}
      </Select>

      <Select
        defaultValue=''
        onChange={(e) => setFilter('type', e.target.value)}
        aria-label='Filter by service category'
      >
        <option value=''>All categories</option>
        {TRANSACTION_TYPE_OPTIONS.map((type) => (
          <option key={type} value={type}>
            {capitalize(type.replace('_', ' '))}
          </option>
        ))}
      </Select>

      <Select
        defaultValue=''
        onChange={(e) => setFilter('source', e.target.value)}
        aria-label='Filter by source'
      >
        <option value=''>All sources</option>
        {TRANSACTION_SOURCE_OPTIONS.map(({ value, label }) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </Select>

      <Select
        defaultValue=''
        onChange={(e) => setFilter('funding', e.target.value)}
        aria-label='Filter by who paid'
      >
        <option value=''>Who paid: anyone</option>
        {TRANSACTION_FUNDING_OPTIONS.map(({ value, label }) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </Select>

      <TextInput
        type='text'
        placeholder='Provider (e.g. mtn, gotv)'
        onChange={(e) => setFilter('provider', e.target.value)}
        aria-label='Filter by provider'
      />

      <DateInput
        type='date'
        onChange={(e) => setFilter('date_from', e.target.value)}
        aria-label='From date'
      />
      <DateInput
        type='date'
        onChange={(e) => setFilter('date_to', e.target.value)}
        aria-label='To date'
      />
    </Container>
  );
};

export default TransactionFiltersBar;

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

const fieldStyles = `
  border: 1px solid #E2DED3;
  border-radius: 10px;
  padding: 8px 12px;
  font-size: 13px;
  color: #0E1A13;
  background-color: white;
`;

const Select = styled.select`
  ${fieldStyles}
`;

const TextInput = styled.input`
  ${fieldStyles}
  width: 160px;
`;

const DateInput = styled.input`
  ${fieldStyles}
`;
